<div class="asc-card">
  <div>
    <img class="asc-card__image" src="{{ image }}" alt="" />
  </div>
  <div class="asc-card__container">
    <ng-content></ng-content>
  </div>
</div>
